import { Component, Input } from '@angular/core';
import { SatDatepickerComponent } from '../picker/sat-datepicker.component';

@Component({
	selector: 'sat-datepicker-toggle',
	templateUrl: './sat-datepicker-toggle.component.html',
	styleUrls: ['./sat-datepicker-toggle.component.scss'],
})
export class SatDatepickerToggleComponent {
	@Input() for?: SatDatepickerComponent;

	openPicker(): void {
		this.for?.open();
	}
}
